"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Term = _interopRequireDefault(require("./Term"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(transcript) {
  if (!Array.isArray(transcript)) throw new Error('bad data fed to transcriptCompiler');
  var value = transcript.map(function (w, index) {
    var wValue = w.w;
    var metaType = _constants.WORD;

    switch (w.meta) {
      case _constants.PUNC:
        metaType = _constants.PUNC;
        break;

      case _constants.TURN:
        metaType = _constants.TURN;
        break;

      default:
        metaType = _constants.WORD;
    }

    var props = _extends({}, w, {
      index: index,
      type: metaType === _constants.TURN ? 'word:turn' : 'word',
      metaType: metaType
    });

    return new _Term["default"]({
      props: props,
      value: wValue
    });
  });
  return new _Term["default"]({
    value: value,
    props: {
      speakers: new Set([_constants.DEFAULT_SPEAKER])
    }
  });
};

exports["default"] = _default;